export const DESC_MAX_LENGTH = 200;
